import { StepEstateLetterToFinancialInstitutionMeta } from '@/modules/guidancestep/models/meta/shared/StepEstateLetterToFinancialInstitutionMeta';

export class Step332566Meta extends StepEstateLetterToFinancialInstitutionMeta {}
